import { createSelector } from 'reselect';
import fp from 'lodash/fp';

export const getVisitHistory = fp.get('report.visitHistory');

export const getAll = createSelector(getVisitHistory, fp.get('all'));

export const getIsFetching = createSelector(
  getVisitHistory,
  fp.get('fetching')
);

export const getIsFetched = createSelector(getVisitHistory, fp.get('fetched'));

export const getFetchingError = createSelector(
  getVisitHistory,
  fp.get('fetchingError')
);

export const getOrder = createSelector(getVisitHistory, fp.get('order'));
